<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['field_name', 'department', 'com_name', 'rank', 'writer_name']"
      :options="[{}, { type: 'date', label: '계획일' }, { type: 'date', label: '작성일', value: 'date', readonly: true }]"
    />

    <!--관리자 그룹-->
    <schedule-editor class="mt-5" title="안전보건 일정" v-model="form.group1" :isPrint="isPrint" :isReadonly="board.readonly" />

    <!--파일첨부-->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" class="mt-5" :is-print="isPrint" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspectionGroup from "@/components/TableInspectionGroup";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import VueCookie from "vue-cookie";
import ScheduleEditor from "@/views/boards/single-page/398/ScheduleEditor.vue";
import moment from "moment";

export default {
  components: {
    ScheduleEditor,
    FieldSelectModule,
    TableInspectionGroup,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    postId() {
      return this.$route.params.post_id;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          this.form[key] = value[key];
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        group1: [],
        fileList: [],
      },
      date: "",
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  mounted() {
    this.date = VueCookie.get("list398_selectday");
    if (!this.postId && !!this.date) {
      this.$nextTick(() => {
        this.form.stdInfo.계획일 = this.date;
      });
    }
  },
  methods: {
    initBreadcrumb() {
    },
  },
};
</script>

<style scoped></style>
